import {
  CloseButton,
  ListContext,
  ListContextValue,
  Stack,
  Typography,
  ValidationErrors,
  newToast,
} from "@compass/core";
import { SubmitButton } from "components";
import { Contributor } from "generated/openApi";
import { useContext } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { setAppToast } from "redux/reducers/appSlice";
import ApiService from "services/apiService";
import { contributorPageRoute } from "../ContributorPage/ContributorPage";

export const ContributorPageHeader = (props: {
  handle: string;
  contributor: Contributor;
  setValidationErrors: (errors: ValidationErrors) => void;
  unsavedChanges: boolean;
}) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const listContext = useContext<ListContextValue>(ListContext);

  const save = (contributor: Contributor) => {
    props.setValidationErrors({});

    ApiService.contributors
      .saveCreate(contributor)
      .then((response) => {
        const id = response;
        navigate(`../${contributorPageRoute.getPath({ id: id, crudMode: "view" })}`);
        listContext.loadList?.();
        dispatch(setAppToast(newToast("success")));
      })
      .catch((ex) => {
        dispatch(setAppToast(newToast("error")));
        props.setValidationErrors(ex.data);
      });
  };

  return (
    <Stack direction="row" justifyContent="space-between">
      <Typography variant="inherit">{props.handle}</Typography>

      <Stack direction="row" alignItems="center" spacing="sm">
        <CloseButton confirm={props.unsavedChanges} />
        <SubmitButton
          onClick={() => save(props.contributor)}
          disabled={props.contributor.id > 0 && !props.unsavedChanges}
        />
      </Stack>
    </Stack>
  );
};
